/**
 * 文件传输状态管理 Store。
 */
import { create } from "zustand";

export type ReceiveStatus = {
	isReceiving: boolean;
	fileName: string;
	receivedBytes: number;
	totalBytes: number;
	progress: number;
	message: string;
};

export type DownloadInfo = {
	url: string;
	fileName: string;
};

type FileTransferStoreState = {
	receiveStatus: ReceiveStatus;
	downloadInfo: DownloadInfo | null;
	setReceiveStatus: (status: ReceiveStatus) => void;
	updateReceiveStatus: (partialStatus: Partial<ReceiveStatus>) => void;
	setDownloadInfo: (info: DownloadInfo | null) => void;
	clearDownloadInfo: () => void;
	resetReceiveStatus: () => void;
};

/**
 * 构建初始文件接收状态。
 */
const createInitialReceiveStatus = (): ReceiveStatus => ({
	isReceiving: false,
	fileName: "",
	receivedBytes: 0,
	totalBytes: 0,
	progress: 0,
	message: "",
});

const useFileTransferStore = create<FileTransferStoreState>((set) => ({
	receiveStatus: createInitialReceiveStatus(),
	downloadInfo: null,
	/**
	 * 覆盖设置接收状态。
	 * @param {object} status
	 */
	setReceiveStatus: (status) => set({ receiveStatus: status }),
	/**
	 * 合并更新接收状态。
	 * @param {object} partialStatus
	 */
	updateReceiveStatus: (partialStatus) =>
		set((state) => ({
			receiveStatus: {
				...state.receiveStatus,
				...partialStatus,
			},
		})),
	/**
	 * 设置下载信息。
	 * @param {{url: string, fileName: string}|null} info
	 */
	setDownloadInfo: (info) => set({ downloadInfo: info }),
	/**
	 * 清理下载信息。
	 */
	clearDownloadInfo: () => set({ downloadInfo: null }),
	/**
	 * 重置接收状态。
	 */
	resetReceiveStatus: () =>
		set({ receiveStatus: createInitialReceiveStatus() }),
}));

export default useFileTransferStore;
